import { Login, Dashboard } from '@screens';

const index = () => {
  const islogged = false;
  return islogged ? <Dashboard /> : <Login />;
};

export default index;
